export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  desc: string;
  count: number;
}

export const categories: Category[] = [
  { id: 'rexue', name: '热血战斗', slug: 'rexue', icon: 'ri-fire-fill', desc: '燃到炸裂的激斗与成长，王道热血不容错过', count: 128 },
  { id: 'xuanhuan', name: '奇幻冒险', slug: 'xuanhuan', icon: 'ri-sword-fill', desc: '魔法、龙与异世界的奇幻旅程', count: 96 },
  { id: 'lianai', name: '恋爱治愈', slug: 'lianai', icon: 'ri-heart-fill', desc: '心动日常与治愈故事，甜度超标', count: 110 },
  { id: 'xuanyi', name: '悬疑推理', slug: 'xuanyi', icon: 'ri-mist-fill', desc: '烧脑谜题与惊悚氛围，反转不断', count: 74 },
  { id: 'kehuan', name: '科幻机甲', slug: 'kehuan', icon: 'ri-rocket-fill', desc: '未来世界、机甲与星际史诗', count: 68 },
  { id: 'gaoxiao', name: '搞笑日常', slug: 'gaoxiao', icon: 'ri-emotion-laugh-fill', desc: '轻松欢乐的沙雕日常，笑到停不下来', count: 152 },
];